import React from 'react';
import ReactDOM from 'react-dom';
import { Modal, Button, Icon } from '@kajabi/sage-react';

import {
  useResultContext,
  useUiResourceContext,
  useConfigContext,
} from 'common/components/CopyMagic/contexts';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';

const DiscardModal = () => {
  const { setOpen, showDiscardModal, setShowDiscardModal } = useUiResourceContext();
  const { resetResult, result, isEdited } = useResultContext();
  const { scopedClassName } = useConfigContext();
  const trackFeedbackSentiment = useGeneratorTrackingCallback('useTrackFeedbackSentiment');
  const trackDiscardClicked = useGeneratorTrackingCallback('useTrackDiscardClicked');

  const handleCancel = () => {
    setShowDiscardModal(false);
    setOpen(true);
  };

  const handleDiscard = () => {
    trackFeedbackSentiment({
      contentId: result?.id,
      metaData: result?.meta,
    });
    trackDiscardClicked({ contentId: result?.id, isEdited: isEdited() });
    resetResult();
    setShowDiscardModal(false);
  };

  if (!showDiscardModal) return null;

  return ReactDOM.createPortal(
    <Modal active className={scopedClassName}>
      <Modal.Header
        aside={
          <Button
            color={Button.COLORS.SECONDARY}
            onClick={handleCancel}
            icon={Icon.ICONS.REMOVE}
            iconOnly={true}
            subtle={true}
          >
            Close
          </Button>
        }
        title="Discard content results?"
      />
      <Modal.Body>
        Are you sure you want to discard this content? This action cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleDiscard} color="danger">
          Discard
        </Button>
      </Modal.Footer>
    </Modal>,
    document.body,
  );
};

export default DiscardModal;
